import { h } from "preact";
import { Card, Row, Col } from 'antd';

const ConfigurationSummary = ({ settings }) => {
    const isFpeEnabled = !settings.turn_off_fpe; // Invert the logic for display

    const activeSettingsCount = isFpeEnabled ?
        Object.entries(settings)
            .filter(([key, value]) =>
                key !== 'allowed_countries' &&
                key !== 'turn_off_fpe' &&
                value === true // Only count explicitly true values, not null
            )
            .length : 0;

    // Check if country blocking is active
    const isCountryBlockingActive = Array.isArray(settings.allowed_countries) && settings.allowed_countries.length > 0;

    return (
        <Card
            title="Current Configuration Summary"
            style={{ marginBottom: '24px', borderLeft: '4px solid #1890ff' }}
        >
            <Row gutter={16}>
                <Col xs={12} md={6}>
                    <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#fafafa', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#262626' }}>
                            {activeSettingsCount}
                        </div>
                        <div style={{ fontSize: '14px', color: '#666' }}>Active Settings</div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#e6f7ff', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
                            {isFpeEnabled ? 'ON' : 'OFF'}
                        </div>
                        <div style={{ fontSize: '14px', color: '#666' }}>Fraud Prevention</div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#f6ffed', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
                            {!isFpeEnabled ? 'Disabled' :
                                (settings.reject_desktop === null ? 'Not Set' :
                                    (settings.reject_desktop ? 'Blocked' : 'Allowed'))}
                        </div>
                        <div style={{ fontSize: '14px', color: '#666' }}>Desktop Access</div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#f9f0ff', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#722ed1' }}>
                            {!isFpeEnabled ? 'Disabled' :
                                (settings.allowed_countries === null ? 'Not Set' :
                                    (isCountryBlockingActive ? settings.allowed_countries.length : 'All'))}
                        </div>
                        <div style={{ fontSize: '14px', color: '#666' }}>Allowed Countries</div>
                    </div>
                </Col>
            </Row>
        </Card>
    );
};

export default ConfigurationSummary;